import React from 'react';
import {useTranslation} from 'react-i18next';
import {MenuItem} from '@techsmith/tsc-cloud-style-guide';

export interface IAudioDescriptionMenu {
   url: string;
   onRemove(): void;
   onReplace(): void;
}

const EditAudioDescriptionMenu: React.FC<IAudioDescriptionMenu> = ({url, onRemove, onReplace}) => {
   const {t} = useTranslation();

   return (
      <>
         <MenuItem
            key="edit-audio-download"
            label={t('accessibility.audioDescription.menu.download')}
            href={url}
            testId="download-menu-item"
         />
         <MenuItem
            key="edit-audio-replace"
            label={t('accessibility.audioDescription.menu.replace')}
            onClick={onReplace}
            testId="replace-menu-item"
         />
         <MenuItem
            key="edit-audio-remove"
            label={t('accessibility.audioDescription.menu.delete')}
            onClick={onRemove}
            testId="delete-menu-item"
         />
      </>
   );
};

export default EditAudioDescriptionMenu;